enum MyleTableTarget {
    Unassigned,
    Myle_Documents_SearchResults_RowClick,
    Myle_Documents_SearchResults_ColumnReorder,
    Myle_Documents_SearchResults_ColumnSortClick,

    Myle_Documents_InboundFaxes_RowClick,
    Myle_Documents_InboundFaxes_ColumnReorder,
    Myle_Documents_InboundFaxes_ColumnSortClick,

    Myle_Calendar_PAList_SearchResults_ColumnSortClick,

    Myle_SearchResults_ColumnReorder,
    Myle_SearchResults_ColumnSortClick,

    Myle_Tasks_SearchResults_ColumnReorder,
    Myle_Tasks_SearchResults_RowClick,

    Myle_CommunicationsRecalls_Search_RowClick,
    Myle_CommunicationsRecalls_Search_ColumnReorder,
    Myle_CommunicationsRecalls_Search_ColumnSortClick,

    Myle_CommunicationsMessages_Search_RowClick,
    Myle_CommunicationsMessages_Search_ColumnReorder,
    Myle_CommunicationsMessages_Search_ColumnSortClick,

    Myle_CommunicationsTasks_Search_RowClick,
    Myle_CommunicationsTasks_Search_ColumnReorder,
    Myle_CommunicationsTasks_Search_ColumnSortClick,

    Myle_ConsultationRequests_Inbox_RowClick,
    Myle_SentFaxes_Inbox_RowClick,

    Myle_PortfolioMyNotes_Search_ColumnSortClick,
    Myle_PortfolioMyNotes_Resident_Search_ColumnSortClick,
    Myle_PortfolioMyConsultationRequests_Search_ColumnSortClick,
    Myle_PortfolioMyRequests_Search_ColumnSortClick,
    Myle_PortfolioMySentFaxes_Search_ColumnSortClick,
    Myle_PortfolioPendingApproval_RowClick,
    Myle_Portfolio_ApssInbox_ColumnSortClick,
    Myle_Portfolio_PortalSync_ColumnSortClick,
    Myle_PortfolioPreventiveRecallList_ColumnSortClick,

    Myle_LabActionsInbox_Search_ColumnSortClick,
    Myle_LabInbox_Search_ColumnSortClick,

    Myle_Lists_Search_ColumnSortClick,

    Myle_PatientCPP_MedicalItemMedicationSortClick,
    Myle_PatientCPP_MedicalItemMedicationReorderClick,
    Myle_PAList_AppointmentStatusCh,

    Myle_AdminBillableServices_ColumnSortClick,

    Myle_AdminLog_ColumnSortClick,

    Myle_AdminService_ColumnSortClick,
    Myle_PreventiveActivities_RowClick,
    Myle_PortfolioPreventiveActivities_ColumnSortClick,

    Myle_Calendar_Appointment_IsPrintCertificateOnSave,
    Myle_PortfolioMyWorkerClaim_Search_ColumnSortClick
}

export { MyleTableTarget };
